<template>
  <div class="pages" v-loading="listLoading">
    <div v-for='(item,index) in templateData.TemplateContent.Controls' :key='index'>
      <Digit v-if='item.Property.Control=="Number"' :data-val='item'></Digit>
      <Contact v-if='item.Property.Control=="Condition"' :data-val="item"></Contact>
      <Dates v-if='item.Property.Control=="Date"' :data-val="item"></Dates>
      <Version v-if='item.Property.Control=="Text"' @child-event='getTextVal' :data-val="item"></Version>
      <Money v-if='item.Property.Control=="Money"' :data-val="item"></Money>
      <Tips v-if='item.Property.Control=="Tips"' :data-val="item"></Tips>
      <File v-if='item.Property.Control=="File"' :data-val="item"></File>
      <Table v-if='item.Property.Control=="Table"' @child-event='tableOperation' :data-val='item'></Table>
      <Selector v-if='item.Property.Control=="Selector"' @child-event='getSelectorVal' :data-val='item'></Selector>
      <Textarea v-if='item.Property.Control=="Textarea"' :data-val='item'></Textarea>
      <Choose v-if='item.Property.Control=="Contact"' @child-event='clickChoose' :data-val='item'></Choose>
    </div>


    <Button class="submit-process" v-on:click='submit' v-bind:disabled="isDisabled" v-bind:loading="formLoading" size="large"
            type="primary"> 提交
    </Button>
  </div>
</template>

<script>
/**
 * Version 为Text文本组件
 */
import Digit from "../components/Number.vue";
import Contact from "../components/Contact.vue";
import Version from "../components/Text.vue";
import Money from "../components/Money.vue";
import Tips from "../components/Tips.vue";
import File from "../components/File.vue";
import Dates from '../components/Date.vue';
import Table from "../components/Table.vue";
import Selector from "../components/Selector.vue";
import Textarea from "../components/Textarea.vue";
import Choose from "../components/Choose.vue";
import wx from "weixin-js-sdk";
import stringUtils from "../assets/js/stringUtil.js";
import { initWxConfig } from "../api/jssdk.js";
import { getTemplateInfo, submitProcess } from "@/api/approval";
import {getAgentInfo, getRelation, getUserInfo} from "@/api/employee"
import { getDepartmentInfo ,getDepartmentRelationByName } from "@/api/department";

var isSubmit = false;

var template = {
  TemplateContent: {
    Controls: [],
  },
};
export default {
  components: {
    Contact,
    Version,
    Money,
    Tips,
    File,
    Table,
    Digit,
    Selector,
    Textarea,
    Choose,
    Dates
  },
  data() {
    return {
      templateData: template,
      relationList: null,
      logInfo: null,
      templateId: "",
      spNo: null,
      formLoading: false,
      listLoading: false,
      isDisabled: false,
      executiveDirector: []
    };
  },
  created() {
    this.logInfo = this.getLoginUserInfo();
    initWxConfig(this);
    this.templateId = this.$route.query.templateId;
    this.spNo = this.$route.query.spNo;
    this.getTemplate();

    stringUtils.setAddIsShow(true);
  },
  methods: {
    clickChoose: async function (dataVal, name) {
      var that = this;
      window.wx.invoke(
          "selectEnterpriseContact",
          {
            fromDepartmentId: 0, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
            mode: "single", // 必填，选择模式，single表示单选，multi表示多选
            type: ["department"], // 必填，选择限制类型，指定department、user中的一个或者多个
            selectedDepartmentIds: [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
            selectedUserIds: [], // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
          },
          async function (res) {
            if (res.err_msg === "selectEnterpriseContact:ok") {
              if (typeof res.result == "string") {
                res.result = JSON.parse(res.result); //由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
              }
              // 已选的部门列表
              var depart = res.result.departmentList[0];
              dataVal.Values = [];
              dataVal.Values.push([depart.id, depart.name]);
              dataVal.Value = depart.name;
            }
          }
      );
    },
    tableOperation (val, type, datas) {
      if (type === "水电物业费用缴纳" || type === "押金意见"){
        this.templateData.TemplateContent.Controls.forEach(col => {
          if (col.Property.Title[0].Text === "新入住宿舍物品发放明细"){
            let showStr = null;
            let children = col.Config.Table.Children;
            children.forEach(child => {
              if (child.Property.Title[0].Text === type){
                let options = child.Config.Selector.Options;
                options.forEach(option => {
                  if (option.Key === val){
                    showStr = option.Value[0].Text;
                  }
                })
              }
              if (type === "水电物业费用缴纳"){
                if (child.Property.Title[0].Text === "未结清原因"){
                  child.IsShow = showStr.indexOf("未结清") > -1;
                }
              }
              if (type === "押金意见"){
                if (child.Property.Title[0].Text === "扣款原因"){
                  child.IsShow = showStr.indexOf("有扣款") > -1;
                }
              }
            })
          }
        })
      }else {
        this.tableoperation(val, type, datas, this);
      }

    },
    getEmployeeRelation: async function() {
      await getRelation(this.logInfo.EmpNo).then( response => {
        this.relationList =  response.Body[0].Nodes;
      });
    },
    getSelectorVal(val, name) {
      let isShowStr = null;
      if (name === "水电物业费用缴纳" || name === "押金退还意见"){
        this.templateData.TemplateContent.Controls.forEach(item =>{
          if (item.Property.Title[0].Text === name){
            let options = item.Config.Selector.Options;
            options.forEach(option => {
              if (option.Key === val){
                isShowStr = option.Value[0].Text
              }
            })
            if (name === "水电物业费用缴纳"){
              this.templateData.TemplateContent.Controls.forEach(ite =>{
                if (ite.Property.Title[0].Text === "未结清原因"){
                  if (isShowStr.indexOf("未结清") > -1){
                    ite.IsShow = true;
                    ite.Property.Require = 1;
                  }else{
                    ite.IsShow = false;
                    ite.Property.Require = 0;
                  }
                }
              })
            }
            if (name === "押金退还意见"){
              this.templateData.TemplateContent.Controls.forEach(ite =>{
                if (ite.Property.Title[0].Text === "未全额退还原因"){
                  if (isShowStr.indexOf("未") > -1){
                    ite.IsShow = true;
                    ite.Property.Require = 1;
                  }else{
                    ite.IsShow = false;
                    ite.Property.Require = 0;
                  }
                }
              })
            }
          }
        })
      }
    },
    getTextVal() {},
    getTemplate: async function () {
      var that = this;
      await that.getEmployeeRelation();
      that.listLoading = true;
      const departName = that.logInfo.fullName;
      const jobLevel = that.logInfo.JobLevel;
      const empName = that.logInfo.EmpName;
      const positionName = that.logInfo.PositionName;
      if(departName.indexOf("营业部/住宅部") === -1 || jobLevel > 3){
        this.Message({
          message: '没有申请权限(只有住宅部且职级为1-3级可申请)',
          type: 'error',
          duration: 2000
        });
        this.isDisabled=true;
      }
      getTemplateInfo(this.templateId).then(async (response) => {
        var controls = response.Body;
        var that = this;
        let executiveDirector = [];
        for (let i = 0; i < controls.TemplateContent.Controls.length; i++){
          let item = controls.TemplateContent.Controls[i];
          if (item.Property.Title[0].Text === "申请人") {
            item.Value = empName;
            item.Disable = true;
          }
          if (item.Property.Title[0].Text.indexOf("原因") > -1) {
            item.IsShow = false;
          }
          if (item.Property.Title[0].Text === "所属战区"){
            let paths = departName.split("/");
            paths.forEach(path => {
              if (path.indexOf("战区") > -1){
                item.Value = path;
                item.Disable = true;
              }
            })
          }
          //数量
          if (item.Property.Title[0].Text === "宿舍返还物品登记"){
            let children = item.Config.Table.Children;
            children.forEach(child => {
              if (child.Property.Title[0].Text === "数量"){
                child.retain = 0;
              }
            })
          }
          if (item.Property.Title[0].Text === "所属大战区"){
            let paths = departName.split("/");
            paths.forEach(path => {
              if (path.indexOf("区") > -1 && path.length === 2){
                item.Value = path;
                item.Disable = true;
              }
            })
          }
          if (item.Property.Title[0].Text === "逐级审批使用"){
            item.Values = await that.getRelationList(that.relationList,7);
            if (item.Values == null || item.Values.length < 1) {
              item.Values.push(this.$store.state.defaultMember);
            } else {
              let datas = item.Values;
              //获取逐级审批最后一个的工号
              let endEmpNo = datas[datas.length - 1][0];
              await getAgentInfo(endEmpNo).then((res) => {
                if (res.Body.PositionName.indexOf("店董") > -1) {
                  item.Values.push(this.$store.state.defaultMember);
                }
              });
            }
            item.IsShow = false;
          }
          if (item.Property.Title[0].Text === "宿舍管理员"){
            item.Values = [];
            await getDepartmentRelationByName(departName,false).then(res => {
              let nodes = res.Body[0].Nodes;
              nodes.forEach(node => {
                let items = node.Items;
                if (items !== null){
                  items.forEach(nItem => {
                    if (nItem.PositionName.indexOf("行政助理") > -1 || nItem.PositionName === "行政主管"){
                      item.Values.push([nItem.EmpNo,nItem.EmpName])
                    }
                    if(nItem.PositionName.indexOf("行政主任") > -1){
                      this.executiveDirector.push([nItem.EmpNo,nItem.EmpName]);
                    }
                  })
                }
              })
            })
            item.IsShow = false;
          }
          if (item.Property.Title[0].Text === "抄送控件"){
            item.Values = [];
            item.IsShow = false;
            item.Values = this.executiveDirector;
            // if (departName.indexOf("东南谯准大战区") > -1){
            //   item.Values.push(["SC11060090","高媛"])
            // }else if(departName.indexOf("东南张彬直带大战区") > -1){
            //   item.Values.push(["SC15003378","吴俊"])
            // }else if(departName.indexOf("东南张家华大战区") > -1){
            //   item.Values.push(["SC15005849","陈姝伶"])
            // }else if(departName.indexOf("东区大战区") > -1){
            //   item.Values.push(["SC16005322","骆言"])
            // }else if(departName.indexOf("大北黄霞大战区") > -1 || departName.indexOf("大北潘强龙大战区") > -1){
            //   item.Values.push(["SC14000308","赵晓平"])
            // }
          }
        }
        this.templateData = this.assignControl(controls, that.logInfo);
        this.listLoading = false;
      });
    },
    submit: async function () {
      //数据校验
      if (!this.submitValidate(this.templateData.TemplateContent.Controls)) {
        return;
      }
      this.templateData.TemplateContent.Controls.forEach(item => {
        if (item.Property.Title[0].Text.indexOf("原因") > -1){
          item.Property.Require = 0;
        }
      })

      this.isDisabled=true;
      var SummaryList = [];
      var info={SummaryInfo:[]}
      info.SummaryInfo=[];

      var info={SummaryInfo:[]}
      info.SummaryInfo=[];
      info.SummaryInfo.push({"Text":"申请人："+" "+ this.logInfo.EmpName ,"Lang":"zh_CN"});
      SummaryList.push(info);
      var info={SummaryInfo:[]}
      info.SummaryInfo=[];
      info.SummaryInfo.push({"Text":"申请部门："+" "+ this.logInfo.DeptName ,"Lang":"zh_CN"});
      SummaryList.push(info);
      var info={SummaryInfo:[]}
      var data = new Date();
      var month =data.getMonth() < 9 ? "0" + (data.getMonth() + 1) : data.getMonth() + 1;
      var date = data.getDate() <= 9 ? "0" + data.getDate() : data.getDate();
      var dateTime = data.getFullYear() + "-" + month + "-" + date;
      info.SummaryInfo=[];
      info.SummaryInfo.push({"Text":"申请时间："+" "+ dateTime ,"Lang":"zh_CN"});
      SummaryList.push(info);
      this.templateData.SummaryList = SummaryList
      //提交
      submitProcess(
          this.templateId,
          this.logInfo.EmpNo,
          this.spNo,
          this.templateData
      )
          .then((response) => {
            this.Message({
              message: "申请成功",
              type: "success",
              duration: 3 * 1000,
            });
            setTimeout(() => {
              this.$router.push("/index");
            }, 3000);
          })
          .catch(err => {
            this.isDisabled=false;
          })
          .finally(() => {
            isSubmit = false;
            this.listLoading = false;
          });
    },
  },
};
</script>

<style scoped>

</style>